import o from "./breakpoints.mjs";
import r from "./colors.mjs";
import t from "./fontSizes.mjs";
import m from "./fontWeights.mjs";
import i from "./fonts.mjs";
import s from "./globalStyles.mjs";
import e from "./lineHeights.mjs";
import f from "./resets.mjs";
import p from "./sizes.mjs";
import a from "./space.mjs";
const u = {
  id: "shared",
  breakpoints: o,
  colors: r,
  globalStyles: s,
  fonts: i,
  fontSizes: t,
  fontWeights: m,
  lineHeights: e,
  resets: f,
  sizes: p,
  space: a
};
export {
  u as default
};
